export const convertToAbs = (value: number, min: number, max: number) => value * (max - min);

export const convertFromAbs = (value: number, min: number, max: number) => value / (max - min);

export function normalizeByStep(value: number, step: number) {
    return Math.round(value / step) * step;
}
